// Front-end enrichment config (Pass 1). No CMS/backend changes.
// Approved case curation + outcome lines per growth situation, and diagnostic mappings.
// Slugs reference existing /api/cases; outcome lines use approved case content only.

export const SITUATION_CASES = {
  "Growth Has Stalled": [
    { slug: "data-into-growth", outcome: "54% revenue growth by turning fragmented customer data into targeted expansion across three cities." },
    { slug: "occasion-into-growth", outcome: "+1.2 units in average consumption per head by extending the drinking occasion." },
    { slug: "efficiency-into-growth-steel", outcome: "24% gain in operational efficiency, with on-time production up from 87% to 96%." },
  ],
  "Ready to Scale": [
    { slug: "structure-into-scale", outcome: "Built and scaled a property-fintech group to US$10.4M in six months." },
    { slug: "concept-into-scale", outcome: "Turned a new wedding-planning category into a US$2.9M business." },
    { slug: "style-into-scale", outcome: "12 stores in three months and US$2.9M+ in the first year." },
  ],
  "Reposition & Transform": [
    { slug: "romance-into-relevance", outcome: "Repositioned a heritage fragrance for a new generation, with 16% sales growth and +1.9 pts market share." },
    { slug: "heritage-into-relevance", outcome: "Reframed natural fragrance for a new generation, driving 9.5% sales growth." },
    { slug: "behaviour-into-growth", outcome: "Shifted behaviour toward herbal pain relief, delivering 30% month-on-month growth." },
  ],
  "Create Enterprise Value": [
    { slug: "efficiency-into-growth", outcome: "61% top-line growth, scaling sales from $24M to $40M through portfolio transformation." },
    { slug: "concept-into-opportunity", outcome: "Turned a private-island vision into an investor-ready luxury ecosystem." },
    { slug: "innovation-into-growth", outcome: "Turned fertility tracking into an investor-backed proposition, inducted into Y Combinator, with 3,459 devices pre-booked." },
  ],
};

// Order of situations as shown in the homepage selector.
export const SITUATION_ORDER = [
  "Growth Has Stalled",
  "Ready to Scale",
  "Reposition & Transform",
  "Create Enterprise Value",
];

// Diagnostic (front-end only; existing AI endpoint stays intact and unused here).
// 3 single-choice questions; each option weights one situation. Result = highest score.
export const DIAGNOSTIC = {
  questions: [
    {
      id: "signal",
      q: "What does the business look like right now?",
      options: [
        { label: "Active, but revenue and demand have flattened", situation: "Growth Has Stalled" },
        { label: "The opportunity is clear, but we can't scale it yet", situation: "Ready to Scale" },
        { label: "The brand or model no longer fits the market", situation: "Reposition & Transform" },
        { label: "Growth needs to be more profitable and investable", situation: "Create Enterprise Value" },
      ],
    },
    {
      id: "blocker",
      q: "What feels like the biggest blocker?",
      options: [
        { label: "Effort is high but nothing moves the numbers", situation: "Growth Has Stalled" },
        { label: "No repeatable system, market focus or structure", situation: "Ready to Scale" },
        { label: "Relevance, proposition or positioning has slipped", situation: "Reposition & Transform" },
        { label: "Margins, valuation or investor story need work", situation: "Create Enterprise Value" },
      ],
    },
    {
      id: "goal",
      q: "What would success look like in 12 months?",
      options: [
        { label: "Growth restarted and moving again", situation: "Growth Has Stalled" },
        { label: "A proven model scaling into new markets", situation: "Ready to Scale" },
        { label: "A brand and model that fit where the market is going", situation: "Reposition & Transform" },
        { label: "A more valuable, more investable business", situation: "Create Enterprise Value" },
      ],
    },
  ],
  // Result phrasing per situation (recommended path). Cases pulled from SITUATION_CASES.
  results: {
    "Growth Has Stalled": {
      title: "Your growth has stalled.",
      path: "The priority is finding the real constraint holding growth back, then rebuilding momentum around execution.",
      href: "/what-we-solve/growth-has-stalled",
    },
    "Ready to Scale": {
      title: "You're ready to scale.",
      path: "The priority is the systems, market focus and structure that turn a working model into repeatable scale.",
      href: "/what-we-solve/ready-to-scale",
    },
    "Reposition & Transform": {
      title: "It's time to reposition or transform.",
      path: "The priority is realigning the brand, proposition or model to where the market is heading.",
      href: "/what-we-solve/reposition-or-transform",
    },
    "Create Enterprise Value": {
      title: "You need to create enterprise value.",
      path: "The priority is making growth more profitable, more durable and more investable.",
      href: "/what-we-solve/create-enterprise-value",
    },
  },
};
